/**
 * Options for the hospital page's "Organization" dropdown (`Account.organizationKey`).
 *
 * Hardcoded until there is an organizations table. Each `value` must match the slug stored in
 * `Account.organizationKey` exactly (lowercase letters, digits and single hyphens — the API
 * validates it). Add a new organization here when one is onboarded. "None" stores null.
 */
export const ORGANIZATION_OPTIONS = [
  { label: "None", value: "" },
  { label: "Ascentist", value: "ascentist" },
];

/**
 * The dropdown's options for a stored value. A key that is not in the list (e.g. one set by SQL
 * that was never added above) is appended with its raw slug as the label, so it is still shown
 * and is not silently cleared when the page is saved.
 */
export function getOrganizationOptions(
  storedKey: string | null | undefined
): { label: string; value: string }[] {
  const key = storedKey ?? "";
  if (ORGANIZATION_OPTIONS.some((option) => option.value === key)) {
    return ORGANIZATION_OPTIONS;
  }
  return [...ORGANIZATION_OPTIONS, { label: key, value: key }];
}
